//LARGE TABLE EXAMPLE 
/* 
import React, { useState } from "react";
import "antd/dist/antd.css";
import "../css/antd_table_custom-1.0.0.css";
import DataTable from "../components/DataTable.js";
*/ 

import React from "react";
import "../assets/css/antd_table_custom-1.0.0.css";
import DataTable from "./DataTable.js";

function LargeDataTable() {
  const columns = [
    {
      id: "1",
      title: "Call date",
      dataIndex: "dateTime",
      defaultSortOrder: "descend",
      sorter: (a, b) => (a.dateTime > b.dateTime ? -1 : 1),
      selected: true,
      value: "something1"
    },
    {
      id: "2",
      title: "Call type",
      dataIndex: "callType",
      defaultSortOrder: "descend",
      sorter: (a, b) => (a.callType > b.callType ? -1 : 1),
      selected: true,
      value: "something2"
    },
    {
      id: "3",
      title: "Other type",
      dataIndex: "otherType",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.otherType.localeCompare(b.otherType),
      selected: true,
      value: "something3"
    },
    {
      id: "4",
      title: "Call sub-type",
      dataIndex: "callSubType",
      selected: true,
      value: "something4"
    },
    {
      id: "5",
      title: "Need review",
      dataIndex: "needReview",
      selected: true,
      value: "something5",
      render: (text) => <span className="export-CSV-Link">{text}</span>,
      filters: [
        {
          text: "Yes",
          value: "Yes"
        },
        {
          text: "No",
          value: "No"
        }
      ],
      onFilter: (value, record) => record.needReview.indexOf(value) === 0
    },
    {
      id: "6",
      title: "HICS activation",
      dataIndex: "HICSActivation",
      selected: true,
      value: "something6",
      filters: [
        {
          text: "Yes",
          value: "Yes"
        },
        {
          text: "No",
          value: "No"
        }
      ],
      onFilter: (value, record) => record.HICSActivation.indexOf(value) === 0
    },
    {
      id: "7",
      title: "AOD",
      dataIndex: "aod",
      selected: true,
      value: "something7"
    },
    {
      id: "8",
      label: "",
      dataIndex: "link",
      selected: true,
      value: "something8",
      render: (text) => <span className="list_item--link"></span>
    }
  ];

  const dataSource = [
    {
      key: "1",
      dateTime: "9/24/2021 @ 3:24 PM",
      callType: "Other",
      otherType: "Rapid Covid",
      callSubType: "ff",
      needReview: "No",
      HICSActivation: "No",
      aod: "a Judith Mahoney",
      link: ">"
    },
    {
      key: "2",
      dateTime: "9/23/2021 @ 1:06 PM",
      callType: "Complaint",
      otherType: "aa",
      callSubType: "cc",
      needReview: "No",
      HICSActivation: "No",
      aod: "b Judith Mahoney",
      link: ">"
    },
    {
      key: "3",
      dateTime: "9/22/2021 @ 11:24 PM",
      callType: "Request for Administrative Guidance",
      otherType: "bb",
      callSubType: "dd",
      needReview: "Yes",
      HICSActivation: "No",
      aod: "c Judith Mahoney",
      link: ">"
    },
    {
      key: "4",
      dateTime: "9/21/2021 @ 5:24 PM",
      callType: "Code Red Activation",
      otherType: "ee",
      callSubType: "Inpatient', P,a,tient/families",
      needReview: "No",
      HICSActivation: "Yes",
      aod: "d Judith Mahoney",
      link: ">"
    },
    {
      key: "5",
      dateTime: "9/26/2021 @ 3:24 PM",
      callType: "Other",
      otherType: "Rapid Covid",
      callSubType: "mm",
      needReview: "No",
      HICSActivation: "No",
      aod: "az Judith Mahoney",
      link: ">"
    },
    {
      key: "6",
      dateTime: "9/27/2021 @ 1:06 PM",
      callType: "Complaint",
      otherType: "nn",
      callSubType: "vv",
      needReview: "No",
      HICSActivation: "No",
      aod: "bw Judith Mahoney",
      link: ">"
    },
    {
      key: "7",
      dateTime: "9/28/2021 @ 11:24 PM",
      callType: "Request for Administrative Guidance",
      otherType: "rr",
      callSubType: "jj",
      needReview: "Yes",
      HICSActivation: "No",
      aod: "cy Judith Mahoney",
      link: ">"
    },
    {
      key: "8",
      dateTime: "9/29/2021 @ 5:24 PM",
      callType: "Code Red Activation",
      otherType: "hh",
      callSubType: "Inpatient', P,a,tient/families",
      needReview: "No",
      HICSActivation: "Yes",
      aod: "dx Judith Mahoney",
      link: ">"
    },

    {
      key: "9",
      dateTime: "1/24/2021 @ 3:24 PM",
      callType: "Other",
      otherType: "Rapid Covid",
      callSubType: "qq",
      needReview: "No",
      HICSActivation: "No",
      aod: "ai Judith Mahoney",
      link: ">"
    },
    {
      key: "10",
      dateTime: "2/23/2021 @ 1:06 PM",
      callType: "Complaint",
      otherType: "ww",
      callSubType: "ee",
      needReview: "No",
      HICSActivation: "No",
      aod: "bu Judith Mahoney",
      link: ">"
    },
    {
      key: "11",
      dateTime: "3/22/2021 @ 11:24 PM",
      callType: "Request for Administrative Guidance",
      otherType: "rr",
      callSubType: "tt",
      needReview: "Yes",
      HICSActivation: "No",
      aod: "cy Judith Mahoney",
      link: ">"
    },
    {
      key: "12",
      dateTime: "4/21/2021 @ 5:24 PM",
      callType: "Code Red Activation",
      otherType: "yy",
      callSubType: "Inpatient', P,a,tient/families",
      needReview: "No",
      HICSActivation: "Yes",
      aod: "dt Judith Mahoney",
      link: ">"
    },
    {
      key: "13",
      dateTime: "5/26/2021 @ 3:24 PM",
      callType: "Other",
      otherType: "Rapid Covid",
      callSubType: "uu",
      needReview: "No",
      HICSActivation: "No",
      aod: "azr Judith Mahoney",
      link: ">"
    },
    {
      key: "14",
      dateTime: "6/27/2021 @ 1:06 PM",
      callType: "Complaint",
      otherType: "ii",
      callSubType: "oo",
      needReview: "No",
      HICSActivation: "No",
      aod: "bwe Judith Mahoney",
      link: ">"
    },
    {
      key: "15",
      dateTime: "7/28/2021 @ 11:24 PM",
      callType: "Request for Administrative Guidance",
      otherType: "oo",
      callSubType: "pp",
      needReview: "Yes",
      HICSActivation: "No",
      aod: "cyw Judith Mahoney",
      link: ">"
    },
    {
      key: "16",
      dateTime: "8/29/2021 @ 5:24 PM",
      callType: "Code Red Activation",
      otherType: "ll",
      callSubType: "Inpatient', P,a,tient/families",
      needReview: "No",
      HICSActivation: "Yes",
      aod: "dxq Judith Mahoney",
      link: ">"
    }
  ];

  function listItemClick(item) {

  }

  return (
    <div>
      <h2>Large Table Example</h2>

      <hr />
      <DataTable
        dataSource={dataSource}
        columns={columns}
        label={"Requires Review/HICS"}
        onSelect={listItemClick}
        id={"datatable_antd"}
        exportCSV={true}
        mobileViewSortEnable={true}
      />
      <hr />
    </div>
  );
}

export default LargeDataTable;
